import type { WatchlistTranslation } from "./index";

export const german = {
  title: "Insights",
  subtitle_team:
    "Verfolge, was in der Arbeit deines Teams zählt, und kehre zu letzten Analysen zurück.",
  subtitle_personal: "Verfolge, was in deiner Arbeit zählt, und kehre zu letzten Analysen zurück.",
  create: "Erstellen",
  track_kpi: "KPI verfolgen",
  track_kpi_hint: "Etwas über die Zeit beobachten",
  run_analysis: "Analyse ausführen",
  run_analysis_hint: "Eine einmalige Frage zu den aktuellen Daten stellen",
  recent_analyses: "Letzte Analysen",
  recent_analyses_empty: "Fragen, die du in dieser Sitzung stellst, erscheinen hier.",
  heading: "Frag alles zu deinen Prozessen",
  setup_heading: "Was möchtest du beobachten?",
  ask_placeholder: "Frage zur Arbeit deines Teams…",
  ask_another_placeholder: "Stelle eine weitere Frage…",
  recent_questions: "Letzte Unterhaltungen",
  delete_chat: "Chat löschen",
  chat_deleted: "Chat gelöscht",
  undo: "Rückgängig",
  dismiss_deleted_chat: "Löschhinweis schließen",
  keep_question_re_running: "Möchtest du diese Frage weiterlaufen lassen?",
  include_in_watchlist: "Zu Insights hinzufügen",
  direct_setup_prompt:
    "Verfolge einen KPI oder beobachte Änderungen — eine wiederkehrende Frage, regelmäßig neu beantwortet",
  direct_setup_active: "Watch wird eingerichtet — wir klären den Umfang vor dem Speichern.",
  direct_setup_reviewing:
    "Watch wird eingerichtet — möglicherweise stellen wir als Nächstes Rückfragen.",
  setup_watch: "Watch einrichten",
  setup_placeholder: "Beschreibe, was du verfolgen möchtest…",
  back_to_ask: "Zurück zu Fragen",
  setup_continue: "Weiter",
  setup_question_progress: "Frage {{current}} von {{total}} (Runde {{round}})",
  setup_recommended: "Empfohlen",
  setup_something_else: "Andere",
  setup_custom_placeholder: "Eigene Antwort eingeben…",
  setup_back: "Zurück",
  setup_next: "Weiter",
  dismiss_keep_question: "Schließen",
  watch_from_conversation: "Mach aus diesem Gespräch eine wiederkehrende Frage.",
  reviewing: "Wird geprüft…",
  saved_and_running: "Als „{{title}}“ gespeichert — läuft gerade",
  title_placeholder: "Diese Meldung benennen",
  all_processes: "Alle Prozesse",
  all_people: "Alle Personen",
  select_processes: "Prozesse auswählen",
  select_people: "Personen auswählen",
  scope_people: "{{count}} Personen",
  scope_people_one: "{{count}} Person",
  scope_processes: "{{count}} Prozesse",
  scope_processes_one: "{{count}} Prozess",
  window_last_n_days: "Letzte {{count}} Tage",
  runs_weekly: "Läuft wöchentlich",
  runs_every_n_days_count: "Läuft alle {{count}} Tage",
  every_n_days: "alle {{count}} Tage",
  your_alerts: "Beobachtet",
  kpis_tracking: "Meine verfolgten KPIs",
  filter_all: "Alle",
  search_alerts: "Meldungen & KPIs durchsuchen…",
  no_matching_alerts: "Keine Meldungen oder KPIs entsprechen diesen Filtern.",
  no_alerts: "Noch nichts verfolgt. Verfolge einen KPI, um eine Frage regelmäßig zu prüfen.",
  never_run: "Noch nie gelaufen",
  chat_about_last_result: "Über das letzte Ergebnis chatten",
  back_to_list: "Zurück zu Insights",
  back_to_chat: "Zurück zum Chat",
  view_in_watchlist: "In Insights ansehen",
  chat_empty_hint:
    "Noch nichts zum Nachfragen — zeichne zuerst deine Arbeit auf und analysiere sie, dann kannst du sie hier befragen.",
  rename_alert: "Alert umbenennen",
  latest_notification: "Letzte Benachrichtigung",
  alert_edited_at: "Alert geändert · {{at}}",
  unread: "Ungelesen",
  suggestion_apps: "Welche Apps haben die meiste Zeit gekostet?",
  suggestion_manual_entry: "Zeitverlust durch manuelle Dateneingabe",
  suggestion_rework: "Welche Schritte werden am häufigsten wiederholt?",
  suggestion_outlier: "Wer führt diesen Prozess anders aus als alle anderen?",
  suggestion_repetitive: "Was ist das Repetitivste, das wir tun?",
  suggestion_automation: "Was ließe sich mit dem größten Nutzen automatisieren?",
  running: "Aktiv",
  run_now: "Jetzt ausführen",
  run_in_progress: "Läuft",
  run_failed: "Ausführung fehlgeschlagen",
  alert_actions: "Meldungsaktionen",
  delete_alert_title: "Meldung löschen?",
  delete_alert_message:
    "Möchtest du „{{title}}“ wirklich löschen? Dadurch werden alle zukünftigen Ausführungen beendet. Dies kann nicht rückgängig gemacht werden.",
  confirm_delete_alert: "Meldung löschen",
  delete_alert_failed: "Meldung konnte nicht gelöscht werden",
  remove_from_scope: "Aus dem Bereich entfernen",
  days_back: "Tage zurück",
  days_between_runs: "Tage zwischen Läufen",
} satisfies WatchlistTranslation;
